import { Link } from '@change-corgi/design-system-legacy/components/actions';

type Props = {
	id: string;
	email: string | null | undefined;
	emailHref: string;
	trackEmailDmClick: (id: string) => void;
};

export function EmailDm({ id, email, emailHref, trackEmailDmClick }: Props): React.JSX.Element | null {
	return email ? (
		<Link
			data-testid="email-dm"
			data-qa="email-dm"
			onClick={() => trackEmailDmClick(id)}
			to={emailHref}
			target="_blank"
		>
			Send email
		</Link>
	) : null;
}
